/**
 * SuperTVGo: mantém a aba tecnicamente "tocando áudio" o tempo todo.
 *
 * Sem isso, o Chrome congela timers e pode descartar a aba inteira
 * (Memory Saver / tab discarding) depois de muito tempo em segundo plano —
 * é a "hibernação" que faz o socket do ActionCable cair e o dashboard só
 * atualizar de novo quando o atendente volta pra aba e clica em
 * "Reconectar". Abas com áudio audível são a exceção documentada a essas
 * duas políticas do Chrome, então um loop bem baixinho (não mudo — mudo não
 * conta como audível) resolve na raiz, em vez de só melhorar a reconexão.
 *
 * O play() de áudio não-mudo só é permitido depois de um gesto do usuário
 * na página — por isso o primeiro play() espera o primeiro clique/tecla.
 */
const SILENT_LOOP_DATA_URI =
  'data:audio/wav;base64,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';

let audio = null;
let gestureListenersAttached = false;

const startPlayback = () => {
  if (!audio) return;
  audio.play().catch(() => {
    // Autoplay ainda bloqueado (raro depois de um gesto real) — tenta de
    // novo no próximo gesto, os listeners só saem depois que tocar de fato.
  });
};

const attachGestureListeners = () => {
  if (gestureListenersAttached) return;
  gestureListenersAttached = true;

  const onGesture = () => {
    startPlayback();
    if (audio && !audio.paused) {
      document.removeEventListener('pointerdown', onGesture);
      document.removeEventListener('keydown', onGesture);
      gestureListenersAttached = false;
    }
  };

  document.addEventListener('pointerdown', onGesture);
  document.addEventListener('keydown', onGesture);
};

export const initKeepTabAlive = () => {
  if (audio) return;

  audio = new Audio(SILENT_LOOP_DATA_URI);
  audio.loop = true;
  audio.volume = 0.02;
  audio.setAttribute('data-supertvgo', 'keep-tab-alive');

  startPlayback();
  attachGestureListeners();
};
